var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreenInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA---05",
    transform: "translate(-876.000000, -298.000000)",
    fill: "#8F9BBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Full-Screen-Copy",
    transform: "translate(876.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,4.75 L14.5,1.75 C14.5,1.61192881 14.3880712,1.5 14.25,1.5 L9.25,1.5 C8.83578644,1.5 8.5,1.16421356 8.5,0.75 C8.5,0.335786438 8.83578644,2.84217094e-14 9.25,2.84217094e-14 L14.25,2.7533531e-14 C15.2164983,2.7533531e-14 16,0.783501688 16,1.75 L16,4.75 C16,5.16421356 15.6642136,5.5 15.25,5.5 C14.8357864,5.5 14.5,5.16421356 14.5,4.75 Z M1.5,11.25 L1.5,14.25 C1.5,14.3880712 1.61192881,14.5 1.75,14.5 L6.75,14.5 C7.16421356,14.5 7.5,14.8357864 7.5,15.25 C7.5,15.6642136 7.16421356,16 6.75,16 L1.75,16 C0.783501688,16 7.38498584e-13,15.2164983 7.38321041e-13,14.25 L7.3776995e-13,11.25 C7.37693861e-13,10.8357864 0.335786438,10.5 0.75,10.5 C1.16421356,10.5 1.5,10.8357864 1.5,11.25 Z M2.5,4 C2.5,3.17157288 3.17157288,2.5 4,2.5 L12,2.5 C12.8284271,2.5 13.5,3.17157288 13.5,4 L13.5,12 C13.5,12.8284271 12.8284271,13.5 12,13.5 L4,13.5 C3.17157288,13.5 2.5,12.8284271 2.5,12 L2.5,4 Z M4,4 L4,12 L12,12 L12,4 L4,4 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenInactive);
export default __webpack_public_path__ + "static/media/full-screen-inactive.a36a8360f304af14065d94c44cf38e9a.svg";
export { ForwardRef as ReactComponent };